export const MAX_FULL_NAME_LENG = 100;
export const MAX_COMPANY_NAME_LENG = 200;
export const MAX_PHONE_NUMBER_LENGTH = 15;
export const MIN_PHONE_NUMBER_LENGTH = 7;
export const MAX_MESSAGE_LENGTH = 400;
export const MAX_WEBSITE_LENGTH = 255;
